module.exports = __webpack_public_path__ + "static/media/descending.1ac0d5ee.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/descending.svg
 ** module id = 608
 ** module chunks = 0
 **/